import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NightlightRoundIcon(props: IconProps) {
    return <Icon {...props} iconKey={"nightlight_round"}/>
}
